import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'bh-awards',
  templateUrl: './bh-awards.component.html',
  styleUrls: ['./bh-awards.component.scss']
})
export class BhAwardsComponent implements OnInit {
  @Input() text: string;
  @Input('type') set _type(_type) {
    if (_type) {
      this.interface.type = _type;
    }
  }

  interface = {
    type: 'default',
    list: [
        {
      "id": 112461, "title": "Best Homeschool Curriculum, Products, Resources of 2024-25", "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Best-Homeschool-Curriculum..jpg",
        "srcset": "",
        "width": 500,
        "height": 500,
        "alt": "Best Homeschool Curriculum.",
        "url": "https://argoprep.online/uploads/winning/Best-Homeschool-Curriculum..jpg"
      }
    }, {
      "id": 83713, "title": "Learner Variability: Product Certification", "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Learner-Variability-with-Banner.png",
        "srcset": "",
        "width": 517,
        "height": 493,
        "alt": "Learner Variability: Product Certification",
        "url": "https://argoprep.online/uploads/winning/Learner-Variability-with-Banner.png"
      }
    }, {
      "id": 32726,
      "title": "Education Hero of The Year",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Education.png",
        "srcset": "",
        "width": 832,
        "height": 832,
        "alt": "Education Hero of The Year",
        "url": "https://argoprep.online/uploads/winning/Education.png"
      }
    }, {
      "id": 11817,
      "title": "Tillywig Brain Child Award",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Brain_Child_hires1.png",
        "srcset": "",
        "width": 300,
        "height": 300,
        "alt": "Tillywig Brain Child Award",
        "url": "https://argoprep.online/uploads/winning/Brain_Child_hires1.png"
      }
    }, {
      "id": 3830,
      "title": "Homeschool  Seal of Approval",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Ellipse-21.png",
        "srcset": "",
        "width": 146,
        "height": 146,
        "alt": "Homeschool Seal of Approval",
        "url": "https://argoprep.online/uploads/winning/Ellipse-21.png"
      }
    }, {
      "id": 2209,
      "title": "Moms Choice Gold Award",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Group-2101.png",
        "srcset": "",
        "width": 146,
        "height": 146,
        "alt": "Mom\u2019s Choice Gold Award",
        "url": "https://argoprep.online/uploads/winning/Group-2101.png"
      }
    }, {
      "id": 2208,
      "title": "Parent\u2019s Choice Gold Award",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Ellipse-2-11.png",
        "srcset": "",
        "width": 146,
        "height": 146,
        "alt": "Parents\u2019s Choice Gold Award",
        "url": "https://argoprep.online/uploads/winning/Ellipse-2-11.png"
      }
    }, {
      "id": 2204,
      "title": "National Parenting Product Award",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Ellipse-2-21.png",
        "srcset": "",
        "width": 146,
        "height": 146,
        "alt": "National Parenting Product Award",
        "url": "https://argoprep.online/uploads/winning/Ellipse-2-21.png"
      }
    }, {
      "id": 32733,
      "title": "The EdTech Leadership Award",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/Leadership.png",
        "srcset": "",
        "width": 1028,
        "height": 1028,
        "alt": "The EdTech Leadership Award",
        "url": "https://argoprep.online/uploads/winning/Leadership.png"
      }
    }, {
      "id": 32730,
      "title": "The EdTech Cool Tool Award",
      "thumbnail": {
        "src": "https://argoprep.online/uploads/winning/EdTech.png",
        "srcset": "",
        "width": 978,
        "height": 978,
        "alt": "The EdTech Cool Tool Award",
        "url": "https://argoprep.online/uploads/winning/EdTech.png"
      }
    }]
  }

  constructor() { }

  ngOnInit(): void {
  }

}
